import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import UserForm from "./UserForm";

const User: React.FC<RouteComponentProps> = () => {
  return <UserForm />;
};

export default withRouter(User);
